import api from './api';
interface FinanceOrderBasisLine { lineRef: string; net: string; tax: string; gross: string }
export type FinanceOrderBasis = { status: 'UNAVAILABLE'; reason: string } | {
  status: 'READ'; basisHash: string; basis: { orderRef: string; currency: string; sourceModifiedAt: string;
    total: string; tax: string; quality: 'OBSERVED_CURRENT_LINES';
    products: Array<FinanceOrderBasisLine & { productRef: string | null; variationRef: string | null; quantity: number }>;
    shipping: FinanceOrderBasisLine[]; fees: FinanceOrderBasisLine[];
  };
};
export interface FinanceOrderEvidence {
  storeId: string; orderId: string;
  archive?: { revisionId: string; recordedAt: string; contentHash: string; bindingRevision: string } | null;
  observedAt: string; currency: string; marketingGrossAmountMatch?: boolean | null;
  sources: { commerce: { status: 'READ'; evidence: { orderBasis?: FinanceOrderBasis } } | { status: 'UNAVAILABLE' };
    payment: { status: 'READ' | 'UNAVAILABLE' } };
  reconciliation: { reportedOrderAmount: string | null; reportedCommerceRefundAmount: string | null;
    reportedPaidAmount: string | null; reportedCompletedRefundAmount: string | null; observedNetPayment: string | null;
    amountMatch: boolean | null; refundAmountMatch: boolean | null; reportedDeliveredParcelCount: number; reasonCodes: string[] };
}
export const financeSourceApi = {
  declaredCosts:(storeId:string,orderId:string,knowledgeAsOf?:string)=>api.get<{
    storeId:string;orderId:string;knowledgeAsOf:string;reasonCodes:string[];
    declaration:{snapshotId:string;version:number;recordedAt:string;observedAt:string;currency:string;basis:'NET';
      quality:'ADMIN_DECLARED_AGGREGATE';evidenceRef:string;declaredNet:string|null;reasonCodes:string[];
      components:Array<{category:'PRODUCT'|'SHIPPING'|'PAYMENT'|'RETURN';charged:string|null;recovered:string|null;declaredNet:string|null}>}|null;
  }>(`/finance/orders/${encodeURIComponent(orderId)}/declared-costs`,{params:{storeId,knowledgeAsOf}}),
  capture: (storeId: string, orderId: string, key: string) => api.post<FinanceOrderEvidence>(
    `/finance/orders/${encodeURIComponent(orderId)}/source-history`, {},
    { params: { storeId }, headers: { 'Idempotency-Key': key }, timeout: 120000 }),
  history: (storeId: string, orderId: string) => api.get<{ hasMore: boolean; revisions: FinanceOrderEvidence[] }>(
    `/finance/orders/${encodeURIComponent(orderId)}/source-history`, { params: { storeId } }),
  order: (storeId: string, orderId: string) => api.get<FinanceOrderEvidence>(
    `/finance/orders/${encodeURIComponent(orderId)}/source-evidence`, { params: { storeId }, timeout: 120000 }),
};
